export default function MySQL_RDBMS() {
  return (
    <div>
      <h2>MySQL_RDBMS</h2>    </div>
  );
}